import React from 'react';
import styled from 'styled-components';

import theme from '../../../../styles/userflow';

interface Props {
  className?: string;
  children: React.ReactNode;
}

const InputHint: React.FC<Props> = ({ children, className }) => (
  <StyledInputHint className={className}>{children}</StyledInputHint>
);
const StyledInputHint = styled.div`
  margin-top: 4px;
  color: ${theme.colors.greyLight};
  max-width: fit-content;
`;

export default InputHint;
